// TFH Sticky Mobile ATC
// Show the sticky bar once the user has scrolled past the primary
// Add-to-Cart button. Hide as soon as they scroll back to where the
// primary button is visible (avoids a duplicate CTA in the user's eye).
// Mobile-only — CSS @media handles the desktop hide.

(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('.tfh-sticky-atc');
    var primaryAtc = document.querySelector('.\\#product-form button[type="submit"]')
                  || document.querySelector('button[name="add"]');
    if (!bar || !primaryAtc) return;

    var ticking = false;

    function update() {
      ticking = false;
      // CSS already hides on desktop, but skip the calc to save cycles
      if (window.innerWidth >= 769) {
        bar.classList.remove('is-visible');
        return;
      }
      var rect = primaryAtc.getBoundingClientRect();
      // Show once the primary ATC has scrolled fully OUT of view (above viewport).
      // Threshold of -20px gives a small buffer so the bar doesn't flicker at the boundary.
      var scrolledPast = rect.bottom < -20;
      if (scrolledPast) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Initial state check (page may already be scrolled if user navigated back)
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
